/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './search-input.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../@angular/material/typings/index.ngfactory';
import * as i3 from '@angular/material';
import * as i4 from '@angular/forms';
import * as i5 from '@covalent/core/search/search-input/search-input.component';
const styles_TdSearchInputComponent:any[] = [i0.styles];
export const RenderType_TdSearchInputComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_TdSearchInputComponent,data:{'animation':[{type:7,name:'searchState',
        definitions:[{type:0,name:'hide-left',styles:{type:6,styles:{transform:'translateX(-150%)',
            display:'none'},offset:(null as any)},options:(undefined as any)},{type:0,
            name:'hide-right',styles:{type:6,styles:{transform:'translateX(150%)',
                display:'none'},offset:(null as any)},options:(undefined as any)},
            {type:0,name:'show',styles:{type:6,styles:{transform:'translateX(0%)',
                display:'block'},offset:(null as any)},options:(undefined as any)},
            {type:1,expr:'* => show',animation:{type:4,styles:(null as any),timings:'200ms ease-in'},
                options:(null as any)},{type:1,expr:'show => *',animation:{type:4,
                styles:(null as any),timings:'200ms ease-out'},options:(null as any)}],
        options:{}}]}});
export function View_TdSearchInputComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵqud(402653184,1,{_input:0}),(_l()(),i1.ɵeld(0,(null as any),
      (null as any),30,'div',[['class','td-search-input'],['layout','row'],['layout-align',
          'end center']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['\n  '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          16,'md-input-container',[['flex',''],['floatPlaceholder','never']],[[2,'mat-hide-underline',
              (null as any)],[1,'align',0],[2,'mat-input-container',(null as any)],
              [2,'mat-input-invalid',(null as any)],[2,'mat-focused',(null as any)],
              [2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',
                  (null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],
              [2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],[[(null as any),
              'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,4)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i2.View_MdInputContainer_0,i2.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i3.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i4.NgForm],[2,i4.FormGroupDirective]],{floatPlaceholder:[0,'floatPlaceholder']},
          (null as any)),i1.ɵqud(335544320,2,{_mdInputChild:0}),i1.ɵqud(335544320,
          3,{_placeholderChild:0}),i1.ɵqud(603979776,4,{_errorChildren:1}),i1.ɵqud(603979776,
          5,{_hintChildren:1}),i1.ɵqud(603979776,6,{_prefixChildren:1}),i1.ɵqud(603979776,
          7,{_suffixChildren:1}),(_l()(),i1.ɵted(1,['\n    '])),(_l()(),i1.ɵeld(0,
          [['searchElement',1]],1,6,'input',[['mdInput',''],['type','search']],[[2,
              'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',
              (null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],
              [2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
                  (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,
                  'required',0],[1,'aria-describedby',0]],[[(null as any),'ngModelChange'],
              [(null as any),'blur'],[(null as any),'search'],[(null as any),'keyup.enter'],
              [(null as any),'input'],[(null as any),'compositionstart'],[(null as any),
                  'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i5.TdSearchInputComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,13)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,13).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,13)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,13)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,18)._onBlur()) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,18)._onFocus()) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,18)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.value = $event)) !== false);
              ad = (pd_7 && ad);
            }
            if (('blur' === en)) {
              const pd_8:any = ((<any>_co.handleBlur()) !== false);
              ad = (pd_8 && ad);
            }
            if (('search' === en)) {
              const pd_9:any = ((<any>_co.stopPropagation($event)) !== false);
              ad = (pd_9 && ad);
            }
            if (('keyup.enter' === en)) {
              const pd_10:any = ((<any>_co.handleSearch($event)) !== false);
              ad = (pd_10 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i4.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i4.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i4.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i4.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i4.NgModel,[[8,(null as any)],
          [8,(null as any)],[8,(null as any)],[2,i4.NG_VALUE_ACCESSOR]],{model:[0,
          'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),i4.NgControl,
          (null as any),[i4.NgModel]),i1.ɵdid(16384,(null as any),0,i4.NgControlStatus,
          [i4.NgControl],(null as any),(null as any)),i1.ɵdid(16384,[[2,4],[1,4]],
          0,i3.MdInputDirective,[i1.ElementRef,i1.Renderer2,[2,i4.NgControl]],{placeholder:[0,
              'placeholder'],type:[1,'type']},(null as any)),(_l()(),i1.ɵted(1,['\n  '])),
      (_l()(),i1.ɵted((null as any),['\n  '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          9,'button',[['class','mat-icon-button'],['flex','none'],['md-icon-button',
              ''],['type','button']],[[24,'@searchState',0],[8,'disabled',0]],[[(null as any),
              'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i5.TdSearchInputComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.clearSearch()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i2.View_MdButton_0,i2.RenderType_MdButton)),i1.ɵdid(16384,(null as any),
          0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(180224,(null as any),0,i3.MdButton,
          [i1.ElementRef,i1.Renderer2,i3.Platform,i3.FocusOriginMonitor],(null as any),
          (null as any)),i1.ɵdid(16384,(null as any),0,i3.MdIconButtonCssMatStyler,
          ([] as any[]),(null as any),(null as any)),(_l()(),i1.ɵted(0,['\n    '])),
      (_l()(),i1.ɵeld(0,(null as any),0,3,'md-icon',[['role','img']],[[2,'mat-icon',
          (null as any)]],(null as any),(null as any),i2.View_MdIcon_0,i2.RenderType_MdIcon)),
      i1.ɵdid(16384,(null as any),0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(9027584,(null as any),
          0,i3.MdIcon,[i1.ElementRef,i1.Renderer2,i3.MdIconRegistry],(null as any),
          (null as any)),(_l()(),i1.ɵted(0,['cancel'])),(_l()(),i1.ɵted(0,['\n  '])),
      (_l()(),i1.ɵted((null as any),['\n']))],(_ck,_v) => {
    var _co:i5.TdSearchInputComponent = _v.component;
    const currVal_12:any = 'never';
    _ck(_v,4,0,currVal_12);
    const currVal_26:any = _co.value;
    _ck(_v,15,0,currVal_26);
    const currVal_27:any = _co.placeholder;
    const currVal_28:any = 'search';
    _ck(_v,18,0,currVal_27,currVal_28);
    _ck(_v,28,0);
  },(_ck,_v) => {
    var _co:i5.TdSearchInputComponent = _v.component;
    const currVal_0:boolean = !_co.showUnderline;
    const currVal_1:any = (null as any);
    const currVal_2:any = true;
    const currVal_3:any = i1.ɵnov(_v,4)._isErrorState();
    const currVal_4:any = i1.ɵnov(_v,4)._mdInputChild.focused;
    const currVal_5:any = i1.ɵnov(_v,4)._shouldForward('untouched');
    const currVal_6:any = i1.ɵnov(_v,4)._shouldForward('touched');
    const currVal_7:any = i1.ɵnov(_v,4)._shouldForward('pristine');
    const currVal_8:any = i1.ɵnov(_v,4)._shouldForward('dirty');
    const currVal_9:any = i1.ɵnov(_v,4)._shouldForward('valid');
    const currVal_10:any = i1.ɵnov(_v,4)._shouldForward('invalid');
    const currVal_11:any = i1.ɵnov(_v,4)._shouldForward('pending');
    _ck(_v,3,1,[currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7,currVal_8,currVal_9,currVal_10,currVal_11]);
    const currVal_13:any = i1.ɵnov(_v,17).ngClassUntouched;
    const currVal_14:any = i1.ɵnov(_v,17).ngClassTouched;
    const currVal_15:any = i1.ɵnov(_v,17).ngClassPristine;
    const currVal_16:any = i1.ɵnov(_v,17).ngClassDirty;
    const currVal_17:any = i1.ɵnov(_v,17).ngClassValid;
    const currVal_18:any = i1.ɵnov(_v,17).ngClassInvalid;
    const currVal_19:any = i1.ɵnov(_v,17).ngClassPending;
    const currVal_20:any = true;
    const currVal_21:any = i1.ɵnov(_v,18).id;
    const currVal_22:any = i1.ɵnov(_v,18).placeholder;
    const currVal_23:any = i1.ɵnov(_v,18).disabled;
    const currVal_24:any = i1.ɵnov(_v,18).required;
    const currVal_25:any = (i1.ɵnov(_v,18).ariaDescribedby || (null as any));
    _ck(_v,12,1,[currVal_13,currVal_14,currVal_15,currVal_16,currVal_17,currVal_18,
        currVal_19,currVal_20,currVal_21,currVal_22,currVal_23,currVal_24,currVal_25]);
    const currVal_29:any = (i1.ɵnov(_v,12).value? 'show': (_co.isRTL? 'hide-left': 'hide-right'));
    const currVal_30:any = (i1.ɵnov(_v,23).disabled || (null as any));
    _ck(_v,21,0,currVal_29,currVal_30);
    const currVal_31:any = true;
    _ck(_v,26,0,currVal_31);
  });
}
export function View_TdSearchInputComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'td-search-input',
      ([] as any[]),(null as any),(null as any),(null as any),View_TdSearchInputComponent_0,
      RenderType_TdSearchInputComponent)),i1.ɵdid(114688,(null as any),0,i5.TdSearchInputComponent,
      [[2,i3.Dir]],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const TdSearchInputComponentNgFactory:i1.ComponentFactory<i5.TdSearchInputComponent> = i1.ɵccf('td-search-input',
    i5.TdSearchInputComponent,View_TdSearchInputComponent_Host_0,{showUnderline:'showUnderline',
        debounce:'debounce',placeholder:'placeholder'},{onSearchDebounce:'searchDebounce',
        onSearch:'search',onClear:'clear',onBlur:'blur'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/$$_gendir/~/@covalent/core/search/search-input/search-input.component.ngfactory.ts